// extracted by mini-css-extract-plugin
export default {"select":"PostTopicAdd-module__select--M7S1H","animatedBackground":"PostTopicAdd-module__animatedBackground--vLzPC"};